<div class="search-filter-operator">
  {{ "and" | translate }}
</div>

<div class="search-filter">
  <span class="search-filter__main">
    <span class="search-filter__title">{{ label }}:</span>
    <span [innerHTML]="render()" class="search-filter__value"></span>
  </span>

  <span
    *ngIf="value?.value?.length === 1 && value?.exactMatch; else notExactMatchTemplate"
    [ngbTooltip]="'Match type' | translate"
    (click)="edit()"
    class="search-filter__match-type"
  >
    <fa-icon icon="equals"></fa-icon>
    <span>{{ "EXACT" | translate }}</span>
  </span>

  <ng-template #notExactMatchTemplate>
    <span
      *ngIf="value?.matchType"
      [ngbTooltip]="'Match type' | translate"
      (click)="edit()"
      class="search-filter__match-type"
    >
      <fa-icon icon="equals"></fa-icon>
      <span>{{ value.matchType }}</span>
    </span>
  </ng-template>

  <span *ngIf="editFields?.length > 0 || mayBeRemoved || infoText" class="search-filter__icons">
    <fa-icon *ngIf="editFields?.length" (click)="edit()" icon="pencil-alt"></fa-icon>

    <fa-icon *ngIf="mayBeRemoved" (click)="remove.emit()" icon="remove"></fa-icon>

    <fa-icon
      *ngIf="infoText"
      [ngbTooltip]="infoText"
      class="cursor-pointer"
      container="body"
      icon="info-circle"
      triggers="click"
    ></fa-icon>
  </span>
</div>
